"use client";

import * as React from "react";
import { cn } from "../../../utils";

export interface CellNotFoundProps {
  className?: string;
}

/**
 * Completed cell whose extraction explicitly returned no value. Visually
 * distinct from the never-run em-dash placeholder rendered by `CellEmpty`.
 */
export function CellNotFound({ className }: CellNotFoundProps) {
  return (
    <span
      className={cn("inline-flex items-center text-sm text-muted-foreground italic", className)}
      aria-label="Not found"
    >
      Not found
    </span>
  );
}
